import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchFixtures,
  type FetchFixturesParams,
  type FixturesData,
  type FixturesResponse,
} from '@/lib/network';

export const FIXTURES_QUERY_KEY_PREFIX = ['matches', 'fixtures'] as const;

export const getFixturesQueryKey = (params?: FetchFixturesParams) =>
  [...FIXTURES_QUERY_KEY_PREFIX, params ?? {}] as const;

export type UseFetchFixturesOptions = Omit<
  UseQueryOptions<FixturesResponse, Error, FixturesData>,
  'queryKey' | 'queryFn'
>;

export const useFetchFixtures = (
  params?: FetchFixturesParams,
  options?: UseFetchFixturesOptions
): UseQueryResult<FixturesData, Error> => {
  return useQuery<FixturesResponse, Error, FixturesData>({
    queryKey: getFixturesQueryKey(params),
    queryFn: () => fetchFixtures(params),
    select: response => response.data,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
};
